import { useMutation } from "@tanstack/react-query";

import { request } from "@/lib/request";
import { Template } from "@/lib/types";
import { useUser } from "../useUserProvider";

export const useApproveTemplate = () => {
  const { accessToken } = useUser();

  return useMutation({
    mutationKey: ["approveTemplate"],
    mutationFn: async ({ templateId }: { templateId: string }): Promise<Template> => {
      if (!accessToken) {
        throw new Error("You need to be logged in to approve templates.");
      }

      const res = await request
        .post<{ data: Template }>(`/templates/${templateId}/approve`)
        .catch(err => {
          throw new Error(
            err.response?.data.message
              ? err.response?.data.message
              : "Failed to approve template.",
          );
        });

      return res.data.data;
    },
  });
};
